const key = 'GEOFENCES__';

// exports.SET_IS_DRAWING = `${key}SET_IS_DRAWING`;
// exports.SET_GEOFENCES_DATA = `${key}SET_GEOFENCES_DATA`;
// exports.SET_GEOFENCE_TO_EDIT = `${key}SET_GEOFENCE_TO_EDIT`;
// exports.SET_GEOMETRY_POLYGON = `${key}SET_GEOMETRY_POLYGON`;

// exports.SET_SEARCH_GEOMETRY_POLYGON = `${key}SEARCHING_GEOMETRY_POLYGON`;

// exports.CREATE_GEOMETRY_POLYGON = `${key}CREATE_GEOMETRY_POLYGON`;
// exports.UPDATE_GEOMETRY_POLYGON = `${key}UPDATE_GEOMETRY_POLYGON`;
// exports.DELETE_GEOMETRY_POLYGON = `${key}DELETE_GEOMETRY_POLYGON`;
// exports.ADD_MULTIPLES_GEOFENCES = `${key}ADD_MULTIPLES_GEOFENCES`;

exports.RESET_STATE = `${key}RESET_STATE`;
